export default __webpack_public_path__ + "8c5dff753df718970fa65e5f80c7084d.png";